module.exports = __webpack_public_path__ + "static/media/tangc.ded76c2e.jpg";